import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
	const ease = "power4.inOut";

	document.body.addEventListener("click", (event) => {
		const link = event.target.closest("a");
		if (!link) return;

		const href = link.getAttribute("href");
		if (!href || href.startsWith("#") || link.target === "_blank" || href === window.location.pathname) return;

		event.preventDefault();

		animateTransition().then(() => {
			window.location.href = href;
		});
	});

	let alreadyRevealed = false;
	let hasInteracted = false;

	document.addEventListener('touchmove', () => {
	if (!hasInteracted) {
		hasInteracted = true;
	}
	});


	revealTransition().then(() => {
		gsap.set(".block", { visibility: "hidden" });
	});

	function revealTransition() {
		if (alreadyRevealed) return Promise.resolve();
			alreadyRevealed = true;

		return new Promise((resolve) => {
			const transition = document.querySelector(".transition")
			transition.classList.add('active')
            gsap.set(".block", { scaleY: 1 });
			gsap.set(".block-reveal-box-text", {
				y: "100%",
				opacity: 0,
				rotateX: 90,
			});

			const tl = gsap.timeline({ defaults: { ease: ease } });

			tl.to(".block-reveal-box-text", {
				duration: 1,
				y: 0,
				opacity: 1,
				rotateX: 0,
				stagger: 0.05,
			})
				.to(".block-reveal-box-text", {
					duration: 1,
					delay: 0.1,
					y: "-100%",
					opacity: 0,
					rotateX: -90,
					stagger: 0.05,
				})
				.to(
					".block",
					{
						scaleY: 0,
						duration: 1,
						stagger: {
							each: 0.1,
							from: "start",
							axis: "x",
						},
						onComplete: () => {
							resolve
							transition.classList.remove('active')
						}
					},
					"-=0.5",
				);
		});
	}

	function animateTransition() {
		return new Promise((resolve) => {
			gsap.set(".block", { visibility: "visible", scaleY: 0 });
			gsap.to(".nav-left", { opacity: 0 });
			gsap.to(".nav-right", { opacity: 0 });
			gsap.to(".projet-back", { opacity: 0 });
			gsap.to(".projet-back", { opacity: 0 });
			gsap.to(".projet-container-grid img", { y: "-800px", opacity: 0 });
			gsap.to(".phone-grid a", { y: "-800px", opacity: 0 });
			gsap.to(".projet-overview-grid img", { y: "-40px", opacity: 0, stagger: 0.05 });
			gsap.to(
				".block-reveal-box-text",
				{
					duration: 1,
					ease: ease,
					y: 0,
				},
				0,
			);
			gsap.to(".block", {
				scaleY: 1,
				duration: 1,
				stagger: {
					each: 0.1,
					from: "start",
					axis: "x",
				},
				ease: ease,
				onComplete: () => {
					resolve();
				},
			});
		});
	}
});
